import make, { Enum } from '@xaamin/enum';

class ReceptoresExcelStatus extends Enum {

  name = 'ReceptoresExcelStatus';

  enum = {
    error: -1,
    valid: 1,
    duplicate: 2,
    updated: 3,
  }

}

export default make(ReceptoresExcelStatus);